import {API_METHODS, apiFetch, policyApiFetch} from "./ApiService.js";
import {
    getPolicyPeopleUrl,
    operationCompleteUrl,
    operationCreateOrUpdateUrl,
    sendEmailBankRefUrl
} from "./EndpointService.js";

export const operationCreateOrUpdate = async (token_arg, type, id) => {
    let url = `${operationCreateOrUpdateUrl}`;
    try {
        return await apiFetch(url, token_arg, API_METHODS.POST, {
            type: type,
            entityId: id
        });
    } catch (error) {
        return null;
    }
}

export const operationComplete = async (token_arg, type, id) => {
    let url = `${operationCompleteUrl}`;
    try {
        return await apiFetch(url, token_arg, API_METHODS.POST, {
            type: type,
            entityId: id
        });
    } catch (error) {
        return null;
    }
}

export const createBankRefByHolder = async (token_arg, id, body) => {
    try {
        return await policyApiFetch(`${getPolicyPeopleUrl}/${id}/bank_ref`, token_arg, API_METHODS.POST, body);
    } catch (error) {
        return null;
    }
};

export const patchBankRefByHolder = async (token_arg, id, body) => {
    try {
        return await policyApiFetch(`${getPolicyPeopleUrl}/${id}/bank_ref`, token_arg, API_METHODS.PATCH, body);
    } catch (error) {
        return null;
    }
};

export const retrieveImageFromList = (list, holder) => {
    if(list) {
        return list.find(image => image.id === holder)?.image;
    } else {
        return null
    }
}

export const sendBankRefMail = async (token_arg, body) => {
    try {
        return await apiFetch(sendEmailBankRefUrl, token_arg, API_METHODS.POST, body);
    } catch (error) {
        return null;
    }
};
